"use client";

import dynamic from "next/dynamic";
import { type Project, type TimelineEntry } from "@/types/types";

// Remove ssr: false so these can be pre-rendered on the server
const HeroSection = dynamic(() => import("@/components/sections/HeroSection"));
const AboutSection = dynamic(() => import("@/components/sections/AboutSection"));
const ProjectsSection = dynamic(() => import("@/components/sections/ProjectsSection"));
const TimelineSection = dynamic(() => import("@/components/sections/TimelineSection"));
const SkillsSection = dynamic(() => import("@/components/sections/SkillsSection"));
const ContactSection = dynamic(() => import("@/components/sections/ContactSection"));

interface HomeClientProps {
  initialProjects: Project[];
  initialTimeline: TimelineEntry[];
}

export default function HomeClient({ initialProjects, initialTimeline }: HomeClientProps) {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <ProjectsSection initialProjects={initialProjects} />
      <TimelineSection initialTimeline={initialTimeline} />
      <SkillsSection />
      <ContactSection />
    </>
  );
}